import React, { cloneElement, isValidElement } from "react";
import PropTypes from "prop-types";
import cx from "classnames";

import Icon from "../icon/icon";
import { gatherClasses } from "../../lib/utils";
import { MenuClose } from "../../lib/icons";
import "./tag.scss";

const Tag = props => {
  const { dataTestId, label, value, closable, onClose, icon } = props;
  return (
    <div data-testid={dataTestId} className={gatherClasses(props, "oui-tag")}>
      {isValidElement(icon)
        ? cloneElement(icon, {
            inheritFontSize: true,
            className: cx(icon.props.className, "oui-mr-1")
          })
        : null}
      {label && <span className="oui-tag-label">{label}:</span>}
      <span className="oui-tag-value oui-text-truncate">{value}</span>
      {closable && (
        <span className="oui-tag-close">
          <Icon
            src={MenuClose}
            size="xs"
            clickable
            onClick={() => {
              if (closable) {
                onClose(props);
              }
            }}
          />
        </span>
      )}
    </div>
  );
};

Tag.propTypes = {
  value: PropTypes.string.isRequired,
  label: PropTypes.string,
  closable: PropTypes.bool,
  onClose: PropTypes.func,
  dataTestId: PropTypes.string,
  icon: PropTypes.element
};

Tag.defaultProps = {
  closable: true,
  onClose: () => {},
  dataTestId: "orion-tag"
};

Tag.displayName = "OrionTag";

export default Tag;
